var exports = {
  "gb": "BaseCell__FuMBbK",
  "az": "Box__9U66KX",
  "K0": "IconButton__kLK-3y",
};

module.exports = exports;
